import { LinkButton } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventTypeOptionResource } from "../../types/eventType";
import { shouldSkipKeyMetricsStep } from "./eventOffboardingStepperUtils";

interface Props {
	eventType: EventTypeOptionResource;
}
export const LinkToOffboardingButton: FC<Props> = ({ eventType }) => {
	const { t } = useTranslation();

	return (
		<LinkButton to={`../offboarding/${shouldSkipKeyMetricsStep(eventType) ? "costs" : "key-metrics"}`}>
			{t("Start offboarding")}
		</LinkButton>
	);
};
